import GeneralStrings from "@strings/GeneralStrings.json";
import { getCurrentYear } from "@utilities/DateHelper";
import "./AppFooter.scss";

export interface AppFooterProps {
  footerHtml?: string;
  year?: number;
}

const AppFooter = ({
  footerHtml = GeneralStrings.footerHtml,
  year = getCurrentYear(),
}: AppFooterProps) => {
  return (
    <footer className="site-footer">
      <hr />
      <div className="copyright">
        <span> © {year} </span>
        <span dangerouslySetInnerHTML={{ __html: footerHtml }} />
      </div>
    </footer>
  );
};

export default AppFooter;
